import VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkinComponent from '../components/VerticalAnchorsMenu/viewer/skinComps/VerticalAnchorsMenuSymbolWithTextSkin/VerticalAnchorsMenuSymbolWithTextSkin.skin';
import VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkinController from '../components/VerticalAnchorsMenu/viewer/VerticalAnchorsMenu.controller';


const VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkin = {
  component: VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkinComponent,
  controller: VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkinController
};


export const components = {
  ['VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkin']: VerticalAnchorsMenu_VerticalAnchorsMenuSymbolWithTextSkin
};

